export class CFile {
    public static readFile(file: File): Promise<Blob> {
        return new Promise((resolve) => {
            const freader = new FileReader();
            freader.onload = (evt) => {
                resolve((evt.target as any).result);
            };
            freader.readAsBinaryString(file);
        });
    }
}
